import { ApplicationConfig, ErrorHandler, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideMarkdown } from 'ngx-markdown';
import { routes } from './app.routes';
import { orbitErrorInterceptor } from './features/orbit/interceptor/orbit-error-interceptor';
import { lightStepInitializer } from './global/providers/lightstep';
import { authHeadersInterceptor } from './shared/interceptors/auth-headers.interceptor';
import { GlobalErrorHandler } from './shared/handlers/global-error.handler';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideHttpClient(withInterceptors([authHeadersInterceptor, orbitErrorInterceptor])),
    provideClientHydration(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      }),
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      })
    ),
    provideAppInitializer(lightStepInitializer),
    provideMarkdown(),
    provideAnimations(),
  ],
};
